import React, { useState } from 'react';
import { Link } from 'gatsby';

const defaultLabels = {
  bannerTitle: 'Cookies and privacy',
  bannerText:
    'We use cookies for analytics (Google Analytics) and advertising (Google AdSense). Choose what to allow.',
  acceptAll: 'Accept all',
  rejectNonEssential: 'Reject non-essential',
  customize: 'Customize',
  saveChoices: 'Save choices',
  analyticsLabel: 'Analytics (understand how the site is used)',
  adsLabel: 'Personalized advertising',
  privacyLink: 'Privacy policy',
  close: 'Close',
};

const CookieConsent = ({ labels, privacyPath, initial, onSave, onClose }) => {
  const L = { ...defaultLabels, ...labels };
  const [showCustomize, setShowCustomize] = useState(false);
  const [analytics, setAnalytics] = useState(initial?.analytics ?? false);
  const [ads, setAds] = useState(initial?.ads ?? false);

  const handleAcceptAll = () => onSave({ analytics: true, ads: true });

  const handleReject = () => onSave({ analytics: false, ads: false });

  const handleSaveCustom = () => onSave({ analytics, ads });

  const isSettingsOnly = Boolean(initial);

  return (
    <div
      className="cookie-consent"
      role="region"
      aria-labelledby="cookie-consent-title"
    >
      <div className="cookie-consent__panel">
        <h2 id="cookie-consent-title" className="cookie-consent__title">
          {L.bannerTitle}
        </h2>
        <p className="cookie-consent__text">{L.bannerText}</p>

        {showCustomize && (
          <div className="cookie-consent__custom">
            <label className="cookie-consent__option" htmlFor="cookie-consent-analytics">
              <input
                type="checkbox"
                id="cookie-consent-analytics"
                checked={analytics}
                onChange={(e) => setAnalytics(e.target.checked)}
              />
              {L.analyticsLabel}
            </label>
            <label className="cookie-consent__option" htmlFor="cookie-consent-ads">
              <input
                type="checkbox"
                id="cookie-consent-ads"
                checked={ads}
                onChange={(e) => setAds(e.target.checked)}
              />
              {L.adsLabel}
            </label>
          </div>
        )}

        <div className="cookie-consent__actions">
          <button type="button" className="btn btn-primary cookie-consent__btn" onClick={handleAcceptAll}>
            {L.acceptAll}
          </button>
          <button type="button" className="btn btn-outline-light cookie-consent__btn" onClick={handleReject}>
            {L.rejectNonEssential}
          </button>
          {showCustomize ? (
            <button type="button" className="btn btn-outline-light cookie-consent__btn" onClick={handleSaveCustom}>
              {L.saveChoices}
            </button>
          ) : null}
        </div>

        <p className="cookie-consent__footer">
          <Link className="cookie-consent__privacy" to={privacyPath}>
            {L.privacyLink}
          </Link>
          <span className="cookie-consent__footer-actions">
            {!showCustomize ? (
              <button type="button" className="cookie-consent__linkish" onClick={() => setShowCustomize(true)}>
                {L.customize}
              </button>
            ) : null}
            {isSettingsOnly ? (
              <button type="button" className="cookie-consent__linkish" onClick={onClose}>
                {L.close}
              </button>
            ) : null}
          </span>
        </p>
      </div>
    </div>
  );
};

export default CookieConsent;
